import { Dispatch } from 'redux';
import { AxiosResponse, AxiosRequestConfig, AxiosError } from 'axios';
import { goBack } from 'connected-react-router';
import { FormikActions } from 'formik';
import { replace } from 'connected-react-router';

import { ILicense } from '../../@types';
import axios from '../../common/axios-instance/axios-instance';
import { ILicenseFormValues } from '../../features/license-entry/license-entry';
import { handleError } from '../utils';
import * as constants from './constants';

export interface IUpdateLicense {
  type: constants.UPDATE_LICENSE;
  payload: ILicense;
}

export interface IClearLicense {
  type: constants.CLEAR_LICENSE;
}

export type LicenseAction = IUpdateLicense | IClearLicense;

export const getLicense = (id: number) => {
  return (dispatch: Dispatch<IUpdateLicense>) => {
    return axios
      .get<ILicense>('/api/license?id=' + id)
      .then((res: AxiosResponse<ILicense>) => {
        return dispatch(updateLicense(res.data));
      })
      .catch(handleError);
  };
};

export const activateLicense = (license: ILicense) => {
  return (dispatch: Dispatch<IUpdateLicense>) => {
    license.status = 'ACTIVE';
    return axios
      .put<ILicense>('/api/license', license)
      .then((res: AxiosResponse<ILicense>) => {
        return dispatch(updateLicense(res.data));
      })
      .catch(handleError);
  };
};

export const deactivateLicense = (license: ILicense) => {
  return (dispatch: Dispatch<IUpdateLicense>) => {
    license.status = 'INACTIVE';
    return axios
      .put<ILicense>('/api/license', license)
      .then((res: AxiosResponse<ILicense>) => {
        return dispatch(updateLicense(res.data));
      })
      .catch(handleError);
  };
};

export const submitLicense = (
  license: ILicense,
  onSuccessfulSubmit: (license: ILicense) => void,
  { setSubmitting, setFieldError }: FormikActions<ILicenseFormValues>
) => {
  return (dispatch: Dispatch) => {
    const axiosRequest: AxiosRequestConfig = {
      method: !license.id ? 'post' : 'put',
      url: '/api/license',
      data: license
    };

    return axios(axiosRequest)
      .then((res: AxiosResponse<ILicense>) => {
        if (!res.data.id) {
          // TODO remove when backend is updated to send an error response in this case
          throw new Error(
            'This license duplicates the bundle id and OS of another license. Please verify that these values are correct'
          );
        }
        onSuccessfulSubmit(res.data);
        setSubmitting(false);
        if (!license.id) {
          dispatch(replace('/licenses/view/' + res.data.id));
        }
      })
      .catch((error: AxiosError) => {
        console.log(error);
        setFieldError('bundleId', error.message);
        setSubmitting(false);
      });
  };
};

export const updateLicense = (license: ILicense): IUpdateLicense => {
  return {
    type: constants.UPDATE_LICENSE,
    payload: license
  };
};

export const clearLicense = (): IClearLicense => {
  return {
    type: constants.CLEAR_LICENSE
  };
};

export const deleteLicense = (id: number) => {
  return (dispatch: Dispatch) => {
    return axios
      .post<ILicense>('/api/license/delete', { id })
      .then(() => {
        return dispatch(clearLicense());
      })
      .then(() => {
        return dispatch(goBack());
      })
      .catch(handleError);
  };
};



// WEBPACK FOOTER //
// ./src/modules/license/action.ts